export default __webpack_public_path__ + "static/transformation-bg-ed68d392990ba3e4c9f87dae37d359dc.jpg";